{
  "app": {
    "name": "Fly",
    "tagline": "Upravljanje vazduhoplovnom flotom"
  },
  "nav": {
    "dashboard": "Pregled",
    "organisation": "Organizacija",
    "profile": "Profil",
    "school": "Škola letjenja",
    "airport": "Aerodrom",
    "members": "Članovi",
    "staff": "Kadar",
    "aircraft": "Vazduhoplovi",
    "fleet": "Flota",
    "logbook": "Knjiga letjenja",
    "maintenance": "Održavanje",
    "alerts": "Upozorenja",
    "settings": "Postavke",
    "taxonomies": "Šifarnici",
    "admin": "Administracija",
    "counters": "Brojači",
    "documents": "Dokumenti"
  },
  "action": {
    "save": "Sačuvaj",
    "cancel": "Otkaži",
    "create": "Kreiraj",
    "edit": "Izmijeni",
    "delete": "Izbriši",
    "close": "Zatvori",
    "search": "Traži",
    "filter": "Filtriraj",
    "clear": "Očisti",
    "export": "Izvezi",
    "exportPdf": "Izvezi PDF",
    "exportXlsx": "Izvezi Excel",
    "refresh": "Osvježi",
    "add": "Dodaj",
    "acknowledge": "Potvrdi",
    "acknowledgeAll": "Potvrdi sve",
    "snooze": "Odloži",
    "resolve": "Riješi",
    "certify": "Ovjeri",
    "correct": "Podnesi ispravku",
    "complete": "Završi",
    "reopen": "Ponovo otvori",
    "signIn": "Prijavi se",
    "signOut": "Odjavi se",
    "retry": "Pokušaj ponovo",
    "back": "Nazad",
    "viewAll": "Prikaži sve",
    "upload": "Otpremi",
    "download": "Preuzmi",
    "adjust": "Koriguj",
    "recompute": "Preračunaj",
    "startWork": "Započni radove",
    "revalidate": "Obnovi",
    "confirm": "Potvrdi"
  },
  "auth": {
    "signInTitle": "Prijava",
    "signInSubtitle": "Upravljanje vazduhoplovnom flotom vašeg kluba",
    "email": "Elektronska adresa",
    "password": "Lozinka",
    "currentPassword": "Trenutna lozinka",
    "newPassword": "Nova lozinka",
    "changePassword": "Izmijeni lozinku",
    "passwordChanged": "Vaša lozinka je izmijenjena.",
    "signInFailed": "Neispravna elektronska adresa ili lozinka.",
    "passwordTooShort": "Koristite najmanje 10 znakova.",
    "passwordMismatch": "Lozinke se ne poklapaju.",
    "noOrganisation": "Vaš račun još nije član nijedne organizacije. Obratite se administratoru.",
    "sessionExpired": "Vaša sesija je istekla. Prijavite se ponovo."
  },
  "common": {
    "yes": "Da",
    "no": "Ne",
    "none": "Nema",
    "all": "Sve",
    "loading": "Učitavanje",
    "noResults": "Nema podataka za prikaz",
    "noResultsHint": "Pokušajte da proširite filtere.",
    "error": "Došlo je do greške",
    "serverUnavailable": "Server trenutno nije dostupan. Pokušajte ponovo za nekoliko minuta.",
    "total": "Ukupno",
    "totals": "Ukupno",
    "summary": "Zbirni prikaz",
    "status": "Status",
    "date": "Datum",
    "from": "Od",
    "to": "Do",
    "notes": "Napomene",
    "remarks": "Primjedbe",
    "name": "Naziv",
    "actions": "Radnje",
    "active": "Aktivno",
    "inactive": "Neaktivno",
    "validUntil": "Važi do",
    "validFrom": "Važi od",
    "daysRemaining": "Preostalo dana",
    "language": "Jezik",
    "theme": "Tema",
    "light": "Svijetla",
    "dark": "Tamna",
    "auto": "Sistemska",
    "organisation": "Organizacija",
    "switchOrganisation": "Promijeni organizaciju",
    "hours": "sati",
    "minutes": "minuta",
    "count": "broj",
    "days": "dana",
    "of": "od",
    "page": "Strana",
    "rowsPerPage": "Redova po strani",
    "showingRange": "{{from}}–{{to}} od {{count}}",
    "unsavedChanges": "Imate nesačuvane izmjene.",
    "confirmDelete": "Trajno izbrisati?",
    "requiredField": "Ovo polje je obavezno."
  },
  "dashboard": {
    "title": "Pregled",
    "fleetStatus": "Stanje flote",
    "airworthy": "Plovidbeno",
    "grounded": "Zabranjeno letjenje",
    "inMaintenance": "Na održavanju",
    "flightsThisYear": "Evidentirano letjenje",
    "openAlerts": "Otvorena upozorenja",
    "overdueMaintenance": "Prekoračeno održavanje",
    "uncertifiedFlights": "Letovi koji čekaju ovjeru",
    "people": "Osoblje",
    "pilots": "Piloti",
    "students": "Učenici piloti",
    "recentFlights": "Skorašnji letovi",
    "expiringDocuments": "Dokumenti kojima ističe rok",
    "monthlyFlying": "Nalet po mjesecima",
    "noFlightsYet": "Još nema evidentiranih letova."
  },
  "organisation": {
    "kind": "Vrsta",
    "CLUB": "Aero klub",
    "FLIGHT_SCHOOL": "Škola letjenja",
    "AIRPORT": "Aerodrom",
    "headInstructor": "Glavni nastavnik letjenja",
    "headOfTraining": "Rukovodilac obuke",
    "safetyManager": "Rukovodilac bezbjednosti",
    "airportManager": "Rukovodilac aerodroma",
    "icaoCode": "ICAO oznaka",
    "iataCode": "IATA oznaka",
    "localIdentifier": "Lokalna oznaka",
    "elevation": "Nadmorska visina (ft)",
    "runways": "Poletno-sletne staze",
    "radioFrequency": "Radio frekvencija",
    "operatingHours": "Radno vrijeme",
    "approvalType": "Vrsta odobrenja",
    "approvalNumber": "Broj odobrenja",
    "competentAuthority": "Nadležni organ",
    "approvedCourses": "Odobreni kursevi",
    "logo": "Logotip",
    "primaryColor": "Osnovna boja",
    "registrationNumber": "Registarski broj",
    "foundedYear": "Godina osnivanja",
    "membershipNumber": "Broj članske karte",
    "postalCode": "Poštanski broj",
    "roles": "Uloge",
    "website": "Internet stranica"
  },
  "staff": {
    "title": "Kadar",
    "person": "Osoba",
    "people": "Osoblje",
    "firstName": "Ime",
    "lastName": "Prezime",
    "dateOfBirth": "Datum rođenja",
    "nationality": "Državljanstvo",
    "phone": "Telefon",
    "email": "Elektronska adresa",
    "pilotStatus": "Status",
    "PILOT": "Pilot",
    "STUDENT_PILOT": "Učenik pilot",
    "INACTIVE": "Ne leti",
    "GROUND_STAFF": "Zemaljsko osoblje",
    "TECHNICIAN": "Tehničar",
    "WINCH_OPERATOR": "Vitlar",
    "ADMINISTRATION": "Administracija",
    "MEMBER": "Član",
    "EXTERNAL": "Spoljni",
    "licences": "Licence",
    "ratings": "Ovlašćenja i privilegije",
    "medical": "Ljekarsko uvjerenje",
    "medicals": "Ljekarska uvjerenja",
    "language": "Poznavanje jezika",
    "certificates": "Uvjerenja",
    "currency": "Trenaža",
    "documents": "Dokumenti",
    "logbook": "Knjiga letjenja",
    "totals": "Ukupan nalet",
    "licenceNumber": "Broj licence",
    "issuingAuthority": "Izdavalac",
    "icaoLevel": "ICAO nivo",
    "scan": "Skenirana kopija",
    "limitations": "Ograničenja",
    "examiner": "Ispitivač",
    "instructor": "Nastavnik letjenja (NL)",
    "soloAuthorised": "Odobreno samostalno letjenje",
    "authorisations": "Odobrenja nastavnika letjenja",
    "isCurrent": "U trenaži",
    "notCurrent": "Van trenaže",
    "VALID": "Važi",
    "EXPIRING": "Ističe uskoro",
    "EXPIRED": "Istekao",
    "MISSING": "Nema ga",
    "SUSPENDED": "Suspendovan",
    "blockingItems": "Onemogućava letjenje",
    "baselineHours": "Prenijeti nalet",
    "addPerson": "Dodaj osobu",
    "address": "Adresa",
    "city": "Grad",
    "emergencyContact": "Kontakt u slučaju nužde",
    "staffKindsHint": "Čime se ova osoba bavi u klubu.",
    "addLicence": "Dodaj licencu",
    "addRating": "Dodaj ovlašćenje",
    "addMedical": "Dodaj ljekarsko uvjerenje",
    "addLanguage": "Dodaj provjeru jezika",
    "addCertificate": "Dodaj uvjerenje",
    "addCurrencyRule": "Dodaj pravilo trenaže",
    "noLicences": "Nema licenci u evidenciji",
    "noRatings": "Nema ovlašćenja u evidenciji",
    "noMedical": "Nema ljekarskog uvjerenja u evidenciji",
    "noLanguage": "Nema provjere jezika u evidenciji",
    "noCertificates": "Nema uvjerenja u evidenciji",
    "noCurrencyRules": "Za ovu osobu još ne važi ni jedno pravilo trenaže",
    "currencyRule": "Pravilo trenaže",
    "metric": "Šta se mjeri",
    "comparison": "Poređenje",
    "soloAuthorisedUntil": "Odobrenje za samostalno letjenje važi do",
    "threshold": "Granica",
    "warnMargin": "Opomeni u okviru",
    "blocksFlying": "Van trenaže onemogućava letjenje",
    "appliesToStatus": "Primjenjuje se na",
    "clubDefault": "Podrazumijevano za klub",
    "personalOverride": "Postavljeno za ovu osobu",
    "measured": "Izmjereno",
    "revalidatedOn": "Obnovljeno",
    "examinationDate": "Datum pregleda",
    "completedOn": "Završeno",
    "suspended": "Suspendovano",
    "warningDays": "Opomeni ovoliko dana prije isteka",
    "ctrEntry": "Dozvoljava ulazak u kontrolisani vazdušni prostor",
    "derivedExpiryHint": "Ostavite prazno da sistem sam izračuna po pravilima.",
    "expiringDocuments": "Dokumenti kojima ističe rok"
  },
  "aircraft": {
    "title": "Vazduhoplovi",
    "fleet": "Flota",
    "registration": "Registracija",
    "competitionNumber": "Takmičarski broj",
    "type": "Tip",
    "category": "Kategorija",
    "class": "Klasa",
    "manufacturer": "Proizvođač",
    "model": "Model",
    "variant": "Varijanta",
    "serialNumber": "Serijski broj",
    "yearOfManufacture": "Godina proizvodnje",
    "seats": "Sjedišta",
    "mtow": "MTOW (kg)",
    "engineCount": "Broj motora",
    "multiPilot": "Predviđen za posadu od više pilota",
    "canTow": "Može da vuče jedrilice",
    "homeBase": "Matični aerodrom",
    "operator": "Operator",
    "owner": "Vlasnik",
    "status": "Status",
    "AIRWORTHY": "Plovidben",
    "IN_MAINTENANCE": "Na održavanju",
    "GROUNDED": "Zabranjeno letjenje",
    "STORED": "U skladištu",
    "SOLD": "Prodat",
    "groundedReason": "Razlog",
    "launchCapabilities": "Načini poletanja",
    "components": "Sklopovi",
    "counters": "Brojači",
    "maintainers": "Održavaoci",
    "airframeHours": "Nalet konstrukcije",
    "landings": "Slijetanja",
    "launches": "Poletanja",
    "counterHistory": "Istorija brojača",
    "currentValue": "Trenutno stanje",
    "initialValue": "Početno stanje",
    "adjustCounter": "Koriguj stanje",
    "adjustCounterHint": "Unesite stvarno stanje na instrumentu. Izmjena se evidentira sa vašim imenom.",
    "airworthiness": "Plovidbenost",
    "cannotFly": "Ovaj vazduhoplov ne smije da leti",
    "addAircraft": "Dodaj vazduhoplov",
    "icaoHint": "ICAO oznaka tipa"
  },
  "logbook": {
    "title": "Knjiga letjenja",
    "AIRCRAFT": "Knjiga letjenja vazduhoplova",
    "PILOT": "Pilotska knjiga letjenja",
    "CLUB": "Knjiga letjenja kluba",
    "SCHOOL": "Knjiga letjenja škole letjenja",
    "AIRPORT": "Knjiga operacija aerodroma",
    "fileFlight": "Unesi let",
    "editFlight": "Izmijeni let",
    "date": "Datum",
    "departurePlace": "Poletanje",
    "departureTime": "Vrijeme poletanja",
    "arrivalPlace": "Slijetanje",
    "arrivalTime": "Vrijeme slijetanja",
    "aircraft": "Vazduhoplov",
    "aircraftType": "Tip vazduhoplova",
    "registration": "Registracija",
    "singlePilotSe": "Jedan pilot, jednomotorni",
    "singlePilotMe": "Jedan pilot, višemotorni",
    "multiPilot": "Više pilota",
    "se": "SE",
    "me": "ME",
    "mp": "MP",
    "totalTime": "Ukupno vrijeme leta",
    "flights": "Letovi",
    "landings": "Slijetanja",
    "uncertifiedOnly": "Čeka ovjeru",
    "noFlights": "Nema letova u ovoj knjizi",
    "noFlightsHint": "Unesite let ili proširite period.",
    "picName": "Vođa / posada",
    "landingsDay": "Slijetanja dan",
    "landingsNight": "Slijetanja noć",
    "night": "Noć",
    "ifr": "IFR",
    "instrument": "Instrumentalno",
    "crossCountry": "Prelet",
    "pic": "VV",
    "copilot": "Kopilot",
    "dual": "Sa nastavnikom",
    "instructorTime": "NL",
    "purpose": "Namjena leta",
    "crew": "Posada i putnici",
    "addCrew": "Dodaj osobu",
    "function": "Funkcija",
    "timeLogged": "Upisano vrijeme",
    "underTraining": "Priznaje se u obuku",
    "tmgSplitHint": "Vrijeme sa radom motora i vrijeme jedrenja moraju zajedno dati ukupno vrijeme leta.",
    "countersign": "Supotpiši",
    "countersignedBy": "Supotpisao",
    "launchMethod": "Način poletanja",
    "launches": "Poletanja",
    "tug": "Avion vučilac",
    "tugPilot": "Pilot vučioca",
    "maxAltitude": "Najveća visina (m)",
    "distance": "Preletjeno (km)",
    "motorTime": "Sa radom motora",
    "glidingTime": "Jedrenje",
    "heaterTime": "Rad gorionika",
    "heatingType": "Zagrijavanje",
    "school": "Škola letjenja",
    "isPaid": "Naplaćeno učesniku",
    "endorsements": "Ovjere",
    "state": "Stanje",
    "DRAFT": "Nacrt",
    "FILED": "Unijet",
    "CERTIFIED": "Ovjeren",
    "CORRECTED": "Zamijenjen ispravkom",
    "certifyConfirm": "Ovjera zaključava ovaj unos. Nakon toga se mijenja samo podnošenjem ispravke.",
    "correctionReason": "Razlog ispravke",
    "cancelReason": "Razlog otkazivanja",
    "counterMovements": "Promjene brojača",
    "runningTotal": "Tekući zbir",
    "broughtForward": "Prenijeto",
    "thisPage": "Ova strana",
    "carriedForward": "Prenosi se",
    "durationHint": "Unesite kao 1:25 ili kao decimalni broj sati.",
    "durationFromTimesHint": "Predloženo iz vremena poletanja i slijetanja. Možete da izmijenite.",
    "picUppercaseHint": "Vođa vazduhoplova se piše velikim slovima, ostali članovi posade običnim.",
    "pendingCertification": "{{count}} unosa čeka ovjeru",
    "noPersonLinked": "Vaš račun nije povezan sa evidencijom osobe, pa još nema pilotsku knjigu letjenja.",
    "timeExceedsFlight": "Upisano vrijeme ne može biti veće od ukupnog vremena leta.",
    "purposes": {
      "INSTRUCTION": "Nastava",
      "TRAINING": "Trenažni let",
      "INTRO_FLIGHT": "Panoramski let",
      "PRIVATE": "Privatno letjenje",
      "CROSS_COUNTRY": "Prelet",
      "TOWING": "Vučenje",
      "MAINTENANCE_TEST": "Probni let nakon održavanja",
      "FERRY": "Prebazirni let",
      "COMPETITION": "Takmičenje",
      "AERIAL_WORK": "Rad iz vazduha",
      "CHECK_FLIGHT": "Ispit vještine ili provjera stručnosti"
    }
  },
  "maintenance": {
    "title": "Održavanje",
    "programme": "Program",
    "tasks": "Poslovi",
    "task": "Posao",
    "due": "Dospijeva",
    "dueList": "Šta dospijeva",
    "log": "Dnevnik održavanja",
    "events": "Zapisi o radovima",
    "templates": "Šabloni",
    "area": "Oblast",
    "AIRFRAME": "Konstrukcija",
    "ENGINE": "Motor",
    "PROPELLER": "Elisa",
    "AVIONICS": "Avionika",
    "EQUIPMENT": "Oprema",
    "ADMINISTRATION": "Administracija",
    "referenceHint": "AMM / SB / AD",
    "camo": "CAMO",
    "interval": "Interval",
    "counterInterval": "Interval po brojaču",
    "calendarMonths": "Kalendarski interval (mjeseci)",
    "tolerance": "Tolerancija",
    "warnBefore": "Upozori prije",
    "lastDone": "Posljednji put obavljeno",
    "dueAtCounter": "Dospijeva na",
    "dueOn": "Dospijeva",
    "remaining": "Preostalo",
    "OK": "U roku",
    "DUE_SOON": "Uskoro dospijeva",
    "DUE": "Dospjelo",
    "IN_TOLERANCE": "U toleranciji",
    "OVERDUE": "Prekoračeno",
    "groundsAircraft": "Zabranjuje letjenje",
    "performedBy": "Izvršio",
    "performedOn": "Datum izvršenja",
    "releasedBy": "Vratio u upotrebu",
    "releaseReference": "Broj potvrde o vraćanju u upotrebu",
    "findings": "Nalazi",
    "partsUsed": "Upotrijebljeni dijelovi",
    "cost": "Trošak",
    "currency": "Valuta",
    "countersAtWork": "Stanje brojača",
    "comments": "Komentari",
    "addComment": "Dodaj komentar",
    "attachments": "Priloženi dokumenti",
    "DRAFT": "Nacrt",
    "OPEN": "U toku",
    "DONE": "Završeno",
    "CANCELLED": "Otkazano",
    "newEvent": "Evidentiraj održavanje",
    "populateProgramme": "Dodaj standardne poslove",
    "populateHint": "Dodaje preglede koje kategorija ovog vazduhoplova uobičajeno ima. Postojeći poslovi se ne mijenjaju.",
    "requiresRelease": "Ovi radovi zahtijevaju potvrdu o vraćanju u upotrebu prije zatvaranja.",
    "fleetOverview": "Održavanje flote"
  },
  "alerts": {
    "title": "Upozorenja",
    "rules": "Pravila",
    "rule": "Pravilo",
    "events": "Upozorenja",
    "notifications": "Obavještenja",
    "metric": "Šta se prati",
    "subject": "Predmet",
    "threshold": "Granica",
    "thresholdMode": "Vrsta granice",
    "leadTimes": "Upozori me na",
    "leadTimesHint": "Jedna ili više vrijednosti prije dospijeća, na primjer 10, 5 i 1 sat.",
    "severity": "Ozbiljnost",
    "INFO": "Informacija",
    "WARNING": "Upozorenje",
    "CRITICAL": "Kritično",
    "channels": "Kako da me obavijesti",
    "IN_APP": "U aplikaciji",
    "EMAIL": "Elektronskom poštom",
    "recipients": "Koga obavijestiti",
    "escalate": "Postaje kritično nakon prekoračenja",
    "cooldown": "Najmanje sati između obavještenja",
    "state": "Stanje",
    "ACTIVE": "Aktivno",
    "ACKNOWLEDGED": "Potvrđeno",
    "SNOOZED": "Odloženo",
    "RESOLVED": "Riješeno",
    "firedAt": "Podignuto",
    "currentReading": "Trenutno stanje",
    "newRule": "Novo pravilo upozorenja",
    "snoozeFor": "Odloži za",
    "snoozeHours": "{{count}} sati",
    "noAlerts": "Ništa ne zahtijeva vašu pažnju.",
    "unacknowledged": "{{count}} nepotvrđenih",
    "evaluateNow": "Provjeri sada",
    "willReach": "Dostiže",
    "metricParameter": "Koji brojač",
    "metricParameterHint": "Ključ brojača koji ovo pravilo prati, na primjer AIRFRAME_HOURS."
  },
  "settings": {
    "title": "Postavke",
    "myProfile": "Moj profil",
    "preferences": "Podešavanja",
    "taxonomies": "Šifarnici",
    "licenceTypes": "Vrste licenci",
    "ratingTypes": "Ovlašćenja i privilegije",
    "certificateTypes": "Vrste uvjerenja",
    "medicalClasses": "Klase ljekarskog uvjerenja",
    "maintenanceTemplates": "Šabloni održavanja",
    "roles": "Uloge",
    "users": "Korisnici",
    "discipline": "Disciplina",
    "POWERED": "Motorno letjenje",
    "GLIDING": "Jedriličarstvo",
    "BALLOON": "Balonarstvo",
    "HELICOPTER": "Helikopteri",
    "AIRSHIP": "Vazdušni brodovi",
    "GENERAL": "Opšte",
    "globalEntry": "Isporučeno sa proizvodom",
    "clubEntry": "Dodao vaš klub",
    "code": "Šifra",
    "shortName": "Kratki naziv",
    "validityMonths": "Važnost (mjeseci)",
    "sortOrder": "Redoslijed",
    "taxonomyHint": "Ovi šifarnici se uređuju u administraciji, gdje se svaki naziv može upisati na oba jezika."
  }
}
